import { Link } from 'react-router-dom'

import Notification from ':/_console/js/components/Notification.tsx'
import { useWorkspaceSlug } from '~/api/swr/useWorkspaceSlug.ts'

const UnpaidInvoicesBanner = () => {
  const { slug } = useWorkspaceSlug()
  // #todo - scroll down to the <Payments/> section when we click on the link?
  return (
    <Notification danger small>
      You still have unpaid invoices. Please
      <Link className="btn btn--inline-link" to={`/c/${slug}/billing`}>
        pay them now
      </Link>
      to prevent your account from being closed.
    </Notification>
  )
}

export default UnpaidInvoicesBanner
